import { AxiosInstance } from "axios";
import { CreateAppSettingsRequest } from "../types/AppSettings/CreateAppSettingsRequest";
import { AppSettings } from "../types/AppSettings/AppSettings";

export default class AppSettingsService {
  private _endpoint = "AppSettings";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public createAppSettings(request: CreateAppSettingsRequest): Promise<void> {
    return this._client
      .post<void>(`${this._endpoint}`, request)
      .then(() => undefined);
  }

  public getLatestSettings(): Promise<AppSettings | null> {
    return this._client
      .get<AppSettings>(`${this._endpoint}`)
      .then((response) => response.data)
      .catch((error) => {
        if (error.response?.status === 404) {
          return null;
        }
        throw error;
      });
  }
}
